exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-d3f498a8] {\n  margin-left: auto;\n}\n.clearcart-btn[data-v-d3f498a8] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n", ""]);

// exports
